import useInputWithReset from '../../input-hooks/useInputWithReset'

import { feedbackForm as form } from '../../../forms/form-objects/feedbackFormObjects'

import {
  getInput,
  getValidation,
  getForm
} from '../../input-hooks/inputFunctions'

const useFeedbackFrom = (record) => {
  const keyArray = Object.keys(form)
  const i = []

  i[i.length] = useInputWithReset(
    getInput(form, keyArray, i.length, record),
    getValidation(form, keyArray, i.length)
  )

  return getForm(keyArray, i)
}

export default useFeedbackFrom
